module.exports = __webpack_public_path__ + "media/theme/SP_HITW_open3-799c744c.png";